// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__saBV9","slidesContainer":"Carousel_slidesContainer__8ugo9","slide":"Carousel_slide__ixkHe"};